import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppLayout,
  BreadcrumbGroup,
  Header,
  Table,
} from '@awsui/components-react';

export default function QuizzesPage(props) {
  // variables
  const [loading, setLoading] = useState(true);
  const [quizzes, setQuizzes] = useState([]);

  // get quizzes from API
  useEffect(() => {
    async function getQuizzes() {
      setQuizzes(await props.api.get({ api: 'TeacherAPI', path: '/quizzes'}));
      setLoading(false);
    };

    getQuizzes();
  }, []);

  // return component
  return (
    <AppLayout
      breadcrumbs={
        <BreadcrumbGroup
          items={
            [
              {
                text: 'Teachers',
                href: '#/teachers',
              },
              {
                text: 'Quizzes',
                href: '#/teachers/quizzes',
              },
            ]
          }
        />
      }
      content={
        <Table
          header={
            // TODO: Add create button
            <Header
              counter={quizzes.length ? `(${quizzes.length})` : ''}
            >
              Quizzes
            </Header>
          }
          loading={loading}
          columnDefinitions={
            [
              {
                id: 'id',
                header: 'ID',
                cell: (item) => <Link to={`/teachers/quizzes/${item.id}`} >{item.id}</Link>,
              },
              {
                id: 'name',
                header: 'Name',
                cell: (item) => item.name,
              },
              {
                id: 'teacher',
                header: 'Teacher',
                cell: (item) => item.teacher,
              },
              {
                id: 'createdAt',
                header: 'Created at',
                cell: (item) => new Date(item.createdAt).toDateString(),
              },
            ]
          }
          items={quizzes}
        />
      }
      navigation={props.nav}
      toolsHide={true}
      headerSelector='#site-header'
      footerSelector='#site-footer'
    />
  )
}